export default __webpack_public_path__ + "static/media/cloud-one.d2351cba.svg";